/* eslint-disable @typescript-eslint/no-this-alias */
import React from 'react';
import { createRoot } from 'react-dom/client';
import BillingAddressSelectContainer from './BillingAddressSelectContainer.jsx';

const BillingAddressSelectRoot = (props) => {
    return <BillingAddressSelectContainer {...props} />
}

export default BillingAddressSelectRoot;

if(typeof window.BillingAddressSelectRoots == 'undefined') {
    window.BillingAddressSelectRoots = {};
}

// MOUNT/UNMOUNT OK
window.BillingAddressSelectRoot = function (sectionTag = 'global') {
    const elements = document.querySelectorAll('[data-react="billing-address-select-container"]');
    
    elements.forEach(element => {
        const uniqueId = element.dataset.windowId || sectionTag;
        
        if (window.BillingAddressSelectRoots[uniqueId] && window.BillingAddressSelectRoots[uniqueId].unmount) {
            window.BillingAddressSelectRoots[uniqueId].unmount();
        }

        let attr = {...BillingAddressSelectRoot.defaultProps};
        attr.windowId = uniqueId;
        attr.defaultValue = element.dataset.defaultValue;

        if (element.dataset.connected_as && element.dataset.connected_as != '') {
            attr.connected_as = element.dataset.connected_as;
        }
        if (element.dataset.membres_id && element.dataset.membres_id != '') {
            attr.membres_id = element.dataset.membres_id;
        }
        if (element.dataset.requests_hotels_id && element.dataset.requests_hotels_id != '') {
            attr.requests_hotels_id = element.dataset.requests_hotels_id;
        }
        
        attr.from = element.dataset.from;
        
        const root = createRoot(element);
        root.render(<BillingAddressSelectRoot {...attr} />);
        
        window.BillingAddressSelectRoots[uniqueId] = root;
    });
};
